import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Thumbs } from 'swiper/modules';
import { useLocation, Link } from "react-router-dom";
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/thumbs';
import instance from '../../services/services';
import { MAKING_SUPPORT_DETAIL_URL, COMM_CREDIT_DETAIL_URL } from '../../utils/urls';
import { formatLocalString } from '../../utils/validation';
import { useLanguage } from '../../hooks/useLanguage';


function SupportPopup({ isPopup, setIsPopup, commType, workSeq }) {
    const { t } = useLanguage();
    const location = useLocation();
    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    const [popupActive, setPopupActive] = useState(false);
    const [detailData, setDetailData] = useState(null);
    const [files, setFiles] = useState([]); 

    useEffect(() => {
        const body = document.body;
        body.style.overflow = isPopup ? 'hidden' : 'auto';
        return () => {
            body.style.overflow = 'auto';
        };
    }, [isPopup]);

    useEffect(() => {
        let timeout;
        if (isPopup) {
            timeout = setTimeout(() => {
                setPopupActive(true);
            }, 100);
        } else {
            setPopupActive(false);
        }
        return () => clearTimeout(timeout);
    }, [isPopup]);

    useEffect(() => {
        document.body.style.overflow = 'auto';
    }, [location]);

    const handleClose = (e) => {
        e.preventDefault();
        setIsPopup(false);
    };

    // 딤 배경 클릭 핸들러 추가
    const handleBackgroundClick = (e) => {
      // popup-box-component 클래스를 가진 최상위 div를 클릭했을 때만 팝업 닫기
      if (e.target.className === 'popup-box-component') {
        setIsPopup(false);
      }
    };
  
    // 제작지원 상세
    useEffect(() => {
      if(commType === 'support'){
      const fetchDetailData = async () => {
        try { 
          const response = await instance.post(MAKING_SUPPORT_DETAIL_URL, {
            work_seq: workSeq
          });
          setDetailData(response.data.data.data);
          setFiles(response.data.data.files);
        } catch (error) {
          console.error("제작지원 상세 정보 가져오기 실패:", error);
        }
      }
        fetchDetailData();
      }
    }, [workSeq, commType]);  


    // 크레딧 상세 정보
    useEffect(() => {
      if(commType === 'credit' && isPopup && workSeq) {
        const fetchDetailData = async () => {
          try { 
            const response = await instance.post(COMM_CREDIT_DETAIL_URL, {
              credit_seq: workSeq
            });
            setDetailData(response.data.data.data);
            setFiles(response.data.data.files);
          } catch (error) {
            console.error("크레딧 상세 정보 가져오기 실패:", error);
          }
        }
        fetchDetailData();
      }
    }, [workSeq, commType, isPopup]);  


    

    if (isPopup)
        return ( 
            <div 
              className="popup-box-component"
              onClick={handleBackgroundClick}
            >
                <div className={`box content event ${popupActive ? 'active' : ''} ${commType === 'support' ? 'support_popup' : ''}`}>
                    <div className="popup_container mh_100">
                      <div className="close_btn_con">
                        <button 
                          type="button" 
                          className="close_btn"
                          onClick={handleClose}
                        />
                      </div>
                      <div className="event_inner support_inner credit_list_page">
                          <div className="event_left">
                            <div className="title_box">
                              <span className="g-80 b3_1">
                                {commType === 'support' ? detailData?.recruitment_year + '년 ' + detailData?.recruitment_month + '월' : detailData?.release_date_year + '년 ' + detailData?.release_date_month + '월'}
                              </span>
                              <h6 className="title ellipsis2">
                                {detailData?.work_title}
                              </h6>
                            </div>
                            <div className="detail_info mt_32">
                              <p className="date flex-8 column">
                                <b>DIRECTOR</b>
                                <span>{detailData?.director}</span>
                              </p>
                              {detailData?.cinematographer && (
                              <p className="date flex-8 column">
                                <b>CINEMATOGRAPHER</b>
                                <span className="g-90 b1_2">{detailData?.cinematographer}</span>
                              </p>
                              )}
                              {/* 크레딧에서만 제작사 출력 */}
                              {commType === 'credit' && (
                                detailData?.producer_name && (
                                <p className="date flex-8 column">
                                  <b>PRODUCTION COMPANY</b>
                                  <span className="g-90 b1_2">{detailData?.producer_name}</span>
                                </p>
                                )
                              )}

                              {/* 제작지원에서만 표출 */}
                              {commType === 'support' && (

                                <p className="date flex-8 column">
                                  <b>{t('production_support_fund')}</b>
                                  <span className="g-90 b1_2">
                                    {detailData?.company_grant ? formatLocalString(detailData?.company_grant) : '0'}<i className="b3_2">원</i>
                                  </span>
                                </p>
                              )}

                              {/* 크레딧에서만 표출 */}
                              {commType === 'credit' && (
                                <>
                                  {detailData?.goodsCameraArray.length > 0 && (
                                  <div className="date flex-8 column gray_line">
                                    <b>CAMERA</b>
                                    <div className='gap_6'>
                                      {detailData?.goodsCameraArray.map((item, index) => (
                                        <Link
                                          to={`/product/detail/${item.goods_seq}`}
                                          key={index}
                                          style={{textDecoration: 'underline'}}
                                          >{item?.goods_name}
                                        </Link>
                                      ))}
                                    </div>
                                  </div>
                                  )}
                                  {detailData?.goodsLensArray.length > 0 && (
                                  <div className="date flex-8 column gray_line">
                                    <b>LENS</b>
                                    <div className='gap_6'>
                                      {detailData?.goodsLensArray.map((item, index) => (
                                        <Link
                                          to={`/product/detail/${item.goods_seq}`}
                                          key={index}
                                          style={{textDecoration: 'underline'}}
                                          >{item?.goods_name}
                                        </Link>
                                      ))}
                                    </div>
                                  </div>
                                  )}
                                </>
                              )}
                            </div>
                          </div>
                          <div className="event_right credit_thumbs">
                          <Swiper
                            modules={[Thumbs, FreeMode]}
                            thumbs={{ swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null }}
                            className="credit_wrap"
                            spaceBetween={10}
                          >
                            {files.map((image, index) => (
                              <SwiperSlide key={index}>
                                <img
                                  src={image.file_url}
                                  alt={`event-${image.id}`}
                                  className="event_img object-cover"
                                  loading="lazy"
                                  style={commType === 'support' ? { aspectRatio: '103 / 69', objectFit: 'cover', width: '100%' } : {}}
                                />
                              </SwiperSlide>
                            ))}
                          </Swiper>
                          {commType === 'credit' && (
                          <Swiper
                            modules={[Thumbs, FreeMode]}
                            watchSlidesProgress={true}
                            freeMode={true}
                            spaceBetween={8}
                            onSwiper={setThumbsSwiper}
                            className="thumbnail"
                          >
                            {files.map((image, index) => (
                              <SwiperSlide key={index}>
                                <img
                                  src={image.file_url}
                                  alt={`thumbnail-${image.id}`}
                                  loading="lazy"
                                />
                              </SwiperSlide>
                            ))}
                          </Swiper>
                          )}
                        </div>
                      </div>
                    </div>
                    {/* 제작지원에서만 표출 */}
                    {commType === 'support' && (
                      <div className="horizontal_scroll_container">
                        <div className="horizontal_scroll_wrapper">
                          {files.map((image, index) => (
                            <div key={index} className="scroll_item">
                              <img
                                src={image.file_url}
                                alt={`thumbnail-${image.id}`}
                                loading="lazy"
                              />
                            </div>
                          ))}
                        </div>
                      </div>
                      )}
                </div>
            </div>
        );
}

export default SupportPopup;
